// extracted by mini-css-extract-plugin
module.exports = {"community":"_2zfVBjxuV3BxhtiIHueR8Y","item":"_3LVGlcdewxeOKCtI_T9lGC"};